import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=25432020"
import script from "./Upgrade.vue?vue&type=script&lang=ts"
export * from "./Upgrade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25432020')) {
      api.createRecord('25432020', component.options)
    } else {
      api.reload('25432020', component.options)
    }
    module.hot.accept("./Upgrade.vue?vue&type=template&id=25432020", function () {
      api.rerender('25432020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/Upgrade.vue"
export default component.exports